var exports = {
  "yA": "x620889e6--b2dbad--app",
  "Qs": "x620889e6--b2dbad--content",
  "J6": "x620889e6--b2dbad--left-column",
  "wW": "x620889e6--b2dbad--right-column",
  "Vx": "x620889e6--b2dbad--specifications",
  "aD": "x620889e6--b2dbad--geo-block",
  "ae": "x620889e6--b2dbad--available-spaces",
};

module.exports = exports;
